import { render } from "./TimetableEntry.vue?vue&type=template&id=517fd32c"
import script from "./TimetableEntry.vue?vue&type=script&lang=js"
export * from "./TimetableEntry.vue?vue&type=script&lang=js"

import "./TimetableEntry.vue?vue&type=style&index=0&id=517fd32c&lang=css"
script.render = render

export default script